import React from "react";

export const ReportCard = (props) => {
    const { title, action } = props;

    return (
        <div className="p-2 col-6 col-md-4 col-lg-3 col-xl-2">
            <div className="card h-100" onClick={action}>
                <h3 className="card-title-pos text-center"> {title} </h3>
                <hr className="hr-pos" />
                <div className="text-center">
                    <img src={require('../images/ico/reporte.png')} alt='' className="img-fluid icon-menu-dashboard" style={{ maxWidth: "47%", marginTop: "8px" }} />
                </div>
            </div>
        </div>
    );
};